export default __webpack_public_path__ + "static/media/042-orca.d9b41b09.svg";